import React, { memo } from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';

import { messages } from './messages';
import styles from './discount-badge.module.less';
import { COUPON, PROMOTION, type DiscountVariant } from '../promotional-price/promotional-price';

type DiscountBadgeProps = {
  discountPercent: number;
  variant?: DiscountVariant;
};

export const DiscountBadge = memo(({ discountPercent, variant = PROMOTION }: DiscountBadgeProps) => {
  const className = variant === COUPON ? styles['coupon-discount-badge'] : styles['discount-badge'];

  return (
    <span className={className}>
      <FormattedMessage
        {...messages.percentOff}
        values={{
          percent: <FormattedNumber maximumFractionDigits={0} style='percent' value={discountPercent / 100} />,
        }}
      />
    </span>
  );
});
